module.exports = __webpack_public_path__ + "img/Web_App_Spanish_image.7e3b7dcd.png";